import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

type AnonymousTrackingContextValue = {
  firmName?: string;
  setFirmName: (firmName?: string) => void;
};

const AnonymousTrackingContext = createContext<AnonymousTrackingContextValue | undefined>(undefined);

export function AnonymousTrackingProvider({ children }: { children: ReactNode }): JSX.Element {
  const [firmName, setFirmName] = useState<string | undefined>(undefined);
  const value = useMemo(() => ({ firmName, setFirmName }), [firmName]);

  return <AnonymousTrackingContext.Provider value={value}>{children}</AnonymousTrackingContext.Provider>;
}

export function useAnonymousTracking(): AnonymousTrackingContextValue {
  const context = useContext(AnonymousTrackingContext);

  if (!context) {
    throw new Error('useAnonymousTracking must be used within AnonymousTrackingProvider');
  }

  return context;
}
